import { z } from "zod";

import copyJson from "./app-route-copy.json";

const text = z.string().min(1);
const navPageSchema = z.object({ navLabel: text, pageDescription: text });
const titledPageSchema = z.object({ pageTitle: text, pageDescription: text });

const copySchema = z.object({
  appName: text,
  routes: z.object({
    dashboard: navPageSchema,
    inventory: navPageSchema,
    scan: navPageSchema,
    transactions: navPageSchema.merge(titledPageSchema),
    orders: navPageSchema,
    contacts: navPageSchema,
    audit: navPageSchema,
    users: navPageSchema,
    auth: titledPageSchema,
    updatePassword: titledPageSchema,
  }),
});

const copy = copySchema.parse(copyJson);

export const APP_NAME_COPY = copy.appName;
export const APP_ROUTE_COPY = copy.routes;
